export default "__VITE_ASSET__CQ8Xu_L9__"